module.exports = __webpack_public_path__ + "img/ca.b71457da.svg";